export const TermsAndConditions = () => {
    return (
        <div>
            <h3>Terms and Conditions</h3>
        </div>
    )
}